import { Directive, HostListener, inject } from '@angular/core';
import { InternalRouteHelperService } from '../../services/internal-route-helper.service';

@Directive({
  selector: '[appRouteDirective]',
  standalone: true,
})
export class RouterLinkDirective {
  private internalRouteHelperService = inject(InternalRouteHelperService);

  @HostListener('click', ['$event'])
  public onClick(e: Event) {
    return this.internalRouteHelperService.handleClick(e);
  }
}
